import { useCallback, useEffect, useState } from 'react';
import { api } from '../api/client';
import { getApiBase } from '../config/runtime';
import { ACCOUNTS } from '../constants';

async function safeRequest(request, fallback) {
  try {
    return await request();
  } catch {
    return fallback;
  }
}

export function useContributionOptions() {
  const [donationProjects, setDonationProjects] = useState([]);
  const [investmentProjects, setInvestmentProjects] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState(ACCOUNTS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const reload = useCallback(async (reconnect = false) => {
    setLoading(true);
    setError('');

    if (reconnect) {
      await api.reconnect();
    }

    const [donationRes, investmentRes, methodsRes] = await Promise.all([
      safeRequest(() => api.getDonationProjects(), { projects: [] }),
      safeRequest(() => api.getInvestmentProjects(), { projects: [] }),
      safeRequest(() => api.getDonationMethods(), { methods: [] }),
    ]);

    const donations = Array.isArray(donationRes?.projects) ? donationRes.projects : [];
    const investments = Array.isArray(investmentRes?.projects) ? investmentRes.projects : [];
    const methods = Array.isArray(methodsRes?.methods) ? methodsRes.methods : [];

    setDonationProjects(donations);
    setInvestmentProjects(investments);
    setPaymentMethods(methods.length ? methods : ACCOUNTS);

    if (donations.length === 0 || investments.length === 0) {
      setError(
        `Could not load projects from ${getApiBase()}. Check your connection or click Try again.`
      );
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    reload(false);
  }, [reload]);

  return {
    donationProjects,
    investmentProjects,
    paymentMethods,
    loading,
    error,
    reload: () => reload(true),
  };
}
